// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionReason-cls1_cpz","cls2":"SuggestionReason-cls2_LZo SuggestionReason-cls1_cpz"};